import { Tool } from '@app/shared/utils';
import { ModuleNameEnum } from '../types/enums';

export const mapToolToModule = (tool: Tool): ModuleNameEnum =>
  ({
    [Tool.Rationing]: ModuleNameEnum.DAILY_ALLOWANCE,
    [Tool.RenalDetect]: ModuleNameEnum.RENAL_DETECT,
    [Tool.SmartReco]: ModuleNameEnum.SMART_RECOMMENDATION,
    [Tool.RapidReco]: ModuleNameEnum.RAPID_RECO,
    [Tool.WeightManagement]: ModuleNameEnum.WEIGHT_MANAGEMENT,
    [Tool.CreatePet]: ModuleNameEnum.UNDEFINED,
  })[tool];
